'use client';

import { ReactNode, useEffect } from 'react';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { SWRConfig } from 'swr';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { ThemeProvider } from './ThemeProvider';
import { sessionCacheProvider } from '@/shared/lib/swr/session-cache-provider';
import { configureRoadAddressInput } from '@miso/design-system';

export function AppProviders({ children }: { children: ReactNode }) {
  useEffect(() => {
    // InquiryFlow의 address 인풋이 사용하는 Kakao 주소 검색 초기화.
    // NEXT_PUBLIC_KAKAO_REST_API_KEY 미설정 시 mock searcher로 fallback (개발 환경에서도 동작).
    configureRoadAddressInput({
      kakaoKey: process.env.NEXT_PUBLIC_KAKAO_REST_API_KEY,
      proxyBase: '/api/kakao-api',
    });
  }, []);

  return (
    <AppRouterCacheProvider>
      <ThemeProvider>
        <SWRConfig
          value={{
            provider: sessionCacheProvider,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            revalidateOnMount: false,
            dedupingInterval: 3600000, // 1시간
          }}
        >
          <AuthProvider>{children}</AuthProvider>
        </SWRConfig>
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
